export enum ADDRESS_MATCH {
  match = 'matchWithApplicant',
  notMatch = 'notMatch',
}
